import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { interval } from 'rxjs';
import { FreemiumAPIService } from '../freemium-api.service';
import { UntypedFormControl, Validators } from '@angular/forms';
import { GaEventsService } from 'src/app/_services/ga-events.service';

@Component({
    selector: 'app-userprofile',
    templateUrl: './userprofile.component.html',
    styleUrls: ['./userprofile.component.scss'],
    standalone: false
})
export class UserprofileComponent implements OnInit {
  @ViewChild('percentageMatchModal') percentageMatchModal: TemplateRef<any>;
  progressValue: number = 0;
  candidatelist: any = [];
  @Input() resumePayload: any;
  showLoader: boolean = false;
  candidateData: any;
  @ViewChild('exportCsvEmailModal') exportCsvEmailModal: TemplateRef<any>;
  @ViewChild('exportSuccessModal') exportSuccessModal: TemplateRef<any>;
  workEmail: UntypedFormControl = new UntypedFormControl('', Validators.required);
  showFreeTrialLoader: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';
  constructor(private modalService: NgbModal, private freemiumAPIService: FreemiumAPIService,
    private gaService: GaEventsService
  ) { }

  ngOnInit() {
    this.freemiumAPIService.getEvaluateErrorHandler.subscribe((res: any) => {
      if (res.status == 'fetch') {
        this.showLoader = true;
        this.progressValue = 0;
        this.resumePayload = res.data;
        this.increaseProgress();

      }
    })
    //this.increaseProgress();
  }

  openPercentageMatchModal(data?: any) {
    const modalref = this.modalService.open(this.percentageMatchModal, { windowClass: 'small-modal ', backdrop: 'static', centered: true });
    this.candidateData = data;
    this.candidateData.overall_screening_score = Math.round(this.candidateData?.overall_screening_score);
  }

  dismissAll() {
    this.modalService.dismissAll()
  }

  increaseProgress() {
    const interval$ = interval(2000); // Change interval duration as needed
    const subscription = interval$.subscribe(() => {
      this.progressValue += 10;
      if (this.progressValue >= 80) {
        this.progressValue = this.candidatelist?.length ? 100 : 99;
      }
      if (this.progressValue === 100) {
        subscription.unsubscribe();
        setTimeout(() => {
          this.showLoader = false;
        }, 500);

      }
    });
    this.getProfiles();
  }

  getProfiles() {
    this.freemiumAPIService.screenResumes(this.resumePayload).subscribe((res: any) => {
      if (res.status == 'success') {
        this.candidatelist = res.data;
        this.candidatelist = this.candidatelist.map(x => {
          x.overall_screening_score = Math.round(x.overall_screening_score);
          return x;
        });
      }
    }, (error) => {
      this.showLoader = false;
      this.candidatelist = [];
      this.errorMessage = 'Something went wrong while processing resumes. Please refresh and try again.';
      setTimeout(() => { this.errorMessage = ''; }, 5000);
      this.freemiumAPIService.emitScreenResumeErrorEvent({ status: 'error', message: 'Something went wrong while processing resumes. Please refresh and try again.' });
    });
  }
  /**
 * Method to return match category
 * @param matchcategory
 * @returns
 */
  showMatchScore(matchcategory: string) {
    let match = '';

    if (matchcategory == 'EXCELLENT') {
      match = 'Excellent Match';
    } else if (matchcategory == 'GOOD') {
      match = 'Good Match';
    } else if (matchcategory == 'POTENTIAL') {
      match = 'Potential Match';
    } else if (matchcategory == 'NOT_A_MATCH') {
      match = 'Not a Match';
    }

    return match;
  };

  /**
 * Method to format AI Summary Text
 * @param text
 */
  formatAISummary(text: string) {
    let cleanedText = text.replace(/<\/?em>/g, '');

    if (!cleanedText.includes('BULLET:-')) {
      return cleanedText.trim();
    }

    const bulletItems = cleanedText.split('BULLET:-')
      .map(item => item.trim())
      .filter(item => item.length > 0);

    const listItems = bulletItems.map(item => `<li>${item}</li>`).join('');
    return `<ul>${listItems}</ul>`;

  };

  openPDF(candidate) {
    this.freemiumAPIService.downloadScreenedResumes(candidate?.resumeurl).subscribe((res: any) => {
      const blobFile = new Blob([res], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blobFile);
      window.parent.postMessage({ action: "openBlob", blobData: res }, "*");

      // console.log(blobUrl);
      // const link = document.createElement('a');
      // link.href = blobUrl;
      // link.target = '_blank';
      // link.click();
    })
  }

  openExportCsvEmailModal() {

    const modalRef = this.modalService.open(this.exportCsvEmailModal, { windowClass: 'small-modal', backdrop: 'static', centered: true });
  }

  register() {
    this.showFreeTrialLoader = true;
    if (this.workEmail.valid) {
      const payload = {
        useremailid: this.workEmail.value,
        screeningdata: this.candidatelist
      }

      this.freemiumAPIService.sendAIScreeningReport(payload).subscribe((res: any) => {
        this.showFreeTrialLoader = false;
        if (res && res.status === 'success') {
              this.gaService.trackButtonClick('Send CSV');

          this.modalService.dismissAll();
          this.modalService.open(this.exportSuccessModal, { windowClass: 'small-modal', backdrop: 'static', centered: true });
          setTimeout(() => {
            this.modalService.dismissAll();
          }, 5000);
        }
      }, (error) => {
      });
    }
  }
}
